import { Link } from 'react-router'
import { PrimaryCta, Reveal } from '@/components/primitives'

export function FinalCta() {
  return (
    <section aria-labelledby="final-cta-heading" className="section-rule relative overflow-hidden">
      <div
        aria-hidden="true"
        className="field-grid pointer-events-none absolute inset-0 opacity-50 [mask-image:radial-gradient(60%_80%_at_50%_50%,black,transparent)]"
      />
      <div className="relative mx-auto w-full max-w-7xl px-5 py-24 sm:px-8 md:py-32">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <h2
              id="final-cta-heading"
              className="text-3xl font-extrabold leading-[1.08] tracking-tight text-ink sm:text-4xl md:text-5xl"
            >
              Show us your operation. We&rsquo;ll map TLDNXS on it.
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink-mute md:text-lg">
              Bring the mess: sources, queues, handoffs, stuck work. We run a live walkthrough on
              your shape of the business.
            </p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
              <PrimaryCta to="/walkthrough">Book a walkthrough</PrimaryCta>
              <Link to="/platform" className="btn-ghost px-0">
                Explore the platform →
              </Link>
            </div>
            <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-mute">
              145M+ policies processed. One stack. One audit trail.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
